import { InjectionToken } from '@angular/core';

export const RuntimeConfigInjectionToken = new InjectionToken('Runtime Config');

export interface RuntimeConfig {
	fileUrl?: string;
}